// Transactions de la fiche dépannage : ce qui lui est propre. La règle de
// modification commune aux 3 fiches (Jordan 19.10) est dans
// utilities/transactionsV2 (miroir de utilitaires/transactions_regle).
// Les règles portent sur les valeurs ENREGISTRÉES (`enregistre`).

import { ADMIN, BOSS, RESPONSABLE } from "../../utilities/transactionsV2"

const enBase = (tx) => tx.enregistre || {}

// Annulation d'un encaissement terrain : quittancée oui (archivée par le
// serveur), datée / rapprochée / facturée / WinBIZ non — sauf pour le boss
// (Jordan 19.10, notes de suivi côté serveur) et l'admin (Jordan 30.10) ;
// le responsable du dépannage annule toute ligne SANS date, à tout état
// (fiche close : refus du serveur).
export const refusAnnulationTerrain = (tx, { niveau } = {}) => {
	if (!tx.dep_mission || !Number.isInteger(tx.id)) return null
	if (niveau === BOSS || niveau === ADMIN) return null
	if (niveau === RESPONSABLE)
		return enBase(tx).date
			? "Encaissement déjà daté : annulable par le boss ou l'admin"
			: tx.winbiz
				? "Envoyé à WinBIZ : il ne s'annule pas"
				: tx.rapprochee
					? "Rapproché d'une ligne bancaire : il ne s'annule pas"
					: null
	if (enBase(tx).date) return "Encaissement déjà daté : il ne s'annule plus"
	if (tx.rapprochee)
		return "Rapproché d'une ligne bancaire : il ne s'annule pas"
	if (tx.facture) return "Facturé : retirer d'abord la facture"
	if (tx.winbiz) return "Envoyé à WinBIZ : il ne s'annule pas"
	return null
}
